import * as React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'react-bootstrap-5';

import './tags_card.scss';
import { map } from 'lodash';

export default class TagsDropdown extends React.Component {
  static propTypes = {
    currentValue: PropTypes.string.isRequired,
    filter: PropTypes.bool,
    firstLoad: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    onAdd: PropTypes.func.isRequired
  };

  newTag = () => {
    const { currentValue } = this.props;

    if (currentValue.length < 3) return null;

    return (
      <Dropdown.Item
        key="newTag"
        onClick={() => this.props.onAdd(currentValue)}
      >
        {`${currentValue} (Create New Tag)`}
      </Dropdown.Item>
    );
  };

  emptyFilterTag = () => {
    return (
      <Dropdown.Item
        disabled={true}
        key="emptyFilterTag"
      >
        No Matching Tags
      </Dropdown.Item>
    );
  }

  suggestions() {
    const { filter, firstLoad, tags } = this.props;

    const tagItems = map(tags, (tag, index) => (
      <Dropdown.Item
        key={index}
        onClick={() => this.props.onAdd(tag)}
      >
        {tag}
      </Dropdown.Item>
    ));

    if (!filter) tagItems.push(this.newTag());
    if (filter && tags.length < 1 && firstLoad) tagItems.push(this.emptyFilterTag());

    return (
      <>
        {tagItems}
      </>
    );
  }

  render() {
    return (
      <ul className="d-block overflow-y-auto w-100 dropdown-menu open" style={{ maxHeight: '240px' }}>
        {this.suggestions()}
      </ul>
    );
  }
}
